class ProductFormSubscription extends HTMLElement {
  constructor() {
    super();

    const elements = {
      radios: this.querySelectorAll("[type=radio]"),
      select: this.querySelector("select")
    };

    const options = this.dataset;

    elements.radios.forEach((radio) => {
      radio.addEventListener("change", (event) => {
        let disabled = true;

        if (event.target.value == "subscription") {
          disabled = false;
        }

        elements.select.disabled = disabled;

        update_url();
      });
    });

    elements.select.addEventListener("change", update_url);

    function update_url() {
      if (!options.updateUrl) {
        return;
      }

      if (elements.select.disabled) {
        Theme.URLParams.delete("selling_plan");
      } else {
        Theme.URLParams.set("selling_plan", elements.select.value);
      }
    }
  }
}

customElements.define("product-form-subscription", ProductFormSubscription);